import Hero from "@/components/home/Hero";
import ScriptureFeature from "@/components/home/ScriptureFeature";
import BeginJourney from "@/components/home/BeginJourney";
import GospelSixTruths from "@/components/home/GospelSixTruths";
import WhoIsJesus from "@/components/home/WhoIsJesus";
import QuestionsFeature from "@/components/home/QuestionsFeature";
import LatestArticles from "@/components/home/LatestArticles";
import LatestBibleStudies from "@/components/home/LatestBibleStudies";
import HindiContent from "@/components/home/HindiContent";
import KidsFeature from "@/components/home/KidsFeature";
import AskPray from "@/components/home/AskPray";
import TrustSection from "@/components/home/TrustSection";
import NewsletterSignup from "@/components/home/NewsletterSignup";

export default function Home() {
  return (
    <>
      <Hero />
      <ScriptureFeature />
      <BeginJourney />
      <GospelSixTruths />
      <WhoIsJesus />
      <QuestionsFeature />
      <LatestArticles />
      <LatestBibleStudies />
      <HindiContent />
      <KidsFeature />
      <AskPray />
      <TrustSection />
      <NewsletterSignup />
    </>
  );
}
